import { getAuthToken } from '@/assets/js/Authentication'
import HttpRequest from './HttpRequest'

class DistributorProductsProvider extends HttpRequest {
  getItems (query) {
    this.setHeader(getAuthToken())
    return this.get('distributor-products', query)
  }

  updateItems (payload) {
    this.setHeader(getAuthToken())
    return this.post('distributor-products', payload)
  }

  importItems (payload) {
    this.setHeader(getAuthToken())
    return this.post('distributor-products/import', payload)
  }

  cloneItems (payload) {
    this.setHeader(getAuthToken())
    return this.post('distributor-products/clone', payload)
  }
}

export default DistributorProductsProvider
